import React, { useState, useEffect } from 'react';

const ProductImagePopup = (props) => {
    const { data, SetStatus } = props;
    const [currentSlide, setCurrentSlide] = useState({});

    useEffect(() => {
        if (data?.selected !== undefined && data.selected !== null &&
            data.list && Array.isArray(data.list) && data.list.length > 0) {
            let _currentSlide = data['list'].find(x => x.image === data.selected);
            if (_currentSlide) {
                setCurrentSlide(_currentSlide);
            }
        }
    }, [])
    
    const onNextSlide = () => {
        setCurrentSlide(data['list'][getCurrentSlideIndex() + 1])
    }
    const onPrevSlide = () => {
        setCurrentSlide(data['list'][getCurrentSlideIndex() - 1])
    }
    const getCurrentSlideIndex = () => {
        if (Object.keys(currentSlide).length > 0) {
            return data['list'].findIndex(x => x.image === currentSlide.image)
        }
        return -2;
    }
    const checkMultipleSlides = () => {
        if (data &&
            data.list &&
            Array.isArray(data.list) && data.list.length > 1) {
            return true;
        }
        return false;
    }
    return (
        <>
            <div className="avnet-modal modal-530">
                <div className="avnet-modal-inner product-detail-popup">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{currentSlide.text}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <button type='button' className={checkMultipleSlides() === false ? 'arrow-btn-left d-none' : (getCurrentSlideIndex() < 1 ? 'arrow-btn-left disabled' : 'arrow-btn-left')} onClick={() => onPrevSlide()}> <span className="fa fa-chevron-left"></span></button>
                        <a href={void (0)} className='mx-5 d-block mb-3 text-center'>
                            <img className='img-fluid' src={currentSlide.image} />
                        </a>
                        <button type='button' className={checkMultipleSlides() === false ? 'arrow-btn-right d-none' : (getCurrentSlideIndex() === (data.list.length - 1) ? 'arrow-btn-right disabled' : 'arrow-btn-right')} onClick={() => onNextSlide()}> <span className="fa fa-chevron-right"></span></button>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                                close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductImagePopup;